import React, {useEffect, useState} from "react";

import Icon from '../atoms/Icon'

const SearchBox = ({placeholder, gettext, buttonSearch, onCancelSearchClick, isCancelVisible}) => {


    return (
        <form className="flex items-center ">
            <label htmlFor="simple-search" className="sr-only">
                Search
            </label>
            <div className="relative w-350 flex flex-row border-gray border-2 rounded-sm justify-between h-10">
                <div className="absolute inset-y-0 right-5 flex items-center pl-3 pointer-events-none">
                    <Icon iconName='search-normal'/>
                </div>
                <input
                    type="text"
                    className="pr-12  text-dark-blue-200 placeholder:text-gray-200   block   text-12 outline-none w-full"
                    placeholder={placeholder}
                    onChange={gettext}
                />
                {
                    isCancelVisible && (
                        <Icon iconName='forbidden-3' onClick={onCancelSearchClick} className={'my-auto ml-[6px]'}/>
                    )
                }

                <button className="px-3.5 text-dark-blue-200 text-12 border-r-2 border-gray mt-2.5 mb-2.5 "
                        onClick={buttonSearch}>بگرد
                </button>
            </div>

        </form>
    );
};

export default SearchBox;
